import React from "react";

import {
  Container,
  Image,
  ContentContainer,
  ContentInner,
  PerfilImg,
  PostTitleContainer,
  PostTitle,
  Text,
  MetricsRow,
  Metrics,
  Point,
  MetricsCol,
  MetricLine,
  BackgroundImage,
  Icon
} from "./styled";

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { Skeleton } from '@mui/material';

const MAPPER_ICONS = {
  "instagram": "/icons/insta-color.svg",
  "youtube": "/icons/galery-color.svg",
  "tiktok": "/icons/tiktok-color.svg",
}

export default function MediaCard({ postUrl, data }) {
  const [loading, setLoading] = React.useState(true);

  function timeAgo(timestamp) {
    // Se tiver 10 dígitos, é segundos → converte para milissegundos
    if (timestamp?.toString().length === 10) {
      timestamp *= 1000;
    }

    const now = Date.now();
    const diffInMs = now - timestamp;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays < 30) {
      return `há ${diffInDays} dia${diffInDays !== 1 ? 's' : ''}`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `há ${diffInMonths} ${diffInMonths !== 1 ? 'meses' : 'mês'}`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `há ${diffInYears} ano${diffInYears !== 1 ? 's' : ''}`;
  }

  function formatNumber(num) {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace('.0', '') + 'M';
    }

    if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace('.0', '') + 'K';
    }

    return num?.toString();
  }

  return (
    <Container>
      {true ? <><BackgroundImage
        src={data?.post_image_url}
        crossorigin="anonymous"
      />

        <Image
          src={data?.post_image_url}
          crossorigin="anonymous"
        />

        <Icon src={MAPPER_ICONS[data?.platform]} />

        <ContentContainer>

          <ContentInner>
            <PerfilImg
              src={data?.creator_image_url}
              crossorigin="anonymous"
            />

            <PostTitleContainer>
              <PostTitle>{data?.post_title}</PostTitle>
              <Text>{timeAgo(new Date(data?.post_date).getTime())}</Text>
            </PostTitleContainer>

            <MetricsRow>
              <Metrics>
                <VisibilityOutlinedIcon fontSize="12px" />
                <Text >{formatNumber(data?.views)}</Text>
              </Metrics>

              <Metrics>
                <FavoriteBorderOutlinedIcon fontSize="12px" sx={{ marginLeft: "19px" }} />
                <Text>{formatNumber(data?.likes)}</Text>
              </Metrics>

              <Metrics>
                <ChatBubbleOutlineRoundedIcon fontSize="12px" sx={{ marginLeft: "19px" }} />
                <Text>{formatNumber(data?.comments)}</Text>
              </Metrics>

              <Metrics style={{ marginLeft: "auto" }}>
                <Point />
                <Text>{data?.engagement_rate.toFixed(2)} ER</Text>
              </Metrics>
            </MetricsRow>

            <MetricsCol>
              <MetricLine>
                <Text>Alcance</Text>
                <Text>{formatNumber(data?.reach)}</Text>
              </MetricLine>

              <MetricLine>
                <Text>Interação</Text>
                <Text>{formatNumber(data?.likes + data?.comments)}</Text>
              </MetricLine>
            </MetricsCol>
          </ContentInner>

        </ContentContainer>
      </>
        : <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
          sx={{ position: 'absolute', top: 0, left: 0 }}
        />}
    </Container>
  );
}
